import React, { useState, useEffect } from 'react';
import './App.css';
import Dashboard from './components/Dashboard';
import { LoadingProvider } from './components/LoadingProvider';
import FullPageLoader from './components/FullPageLoader';
import { getAuthConfig } from './config/auth';
import { getRequireJwtAuth, runAuthCheck } from './services/authService';

function App() {
  const [authStatus, setAuthStatus] = useState('pending');

  useEffect(() => {
    const { isLocal } = getAuthConfig();
    if (isLocal) {
      setAuthStatus('ok');
      return;
    }
    getRequireJwtAuth().then((requireJwtAuth) => {
      if (!requireJwtAuth) {
        setAuthStatus('ok');
        return;
      }
      runAuthCheck().then((allowed) => {
        if (allowed) setAuthStatus('ok');
      });
    });
  }, []);

  if (authStatus !== 'ok') {
    return (
      <FullPageLoader
        isVisible
        message="Verifica accesso in corso..."
      />
    );
  }

  return (
    <LoadingProvider>
      <div className="App">
        <header className="App-header">
          <Dashboard/>
        </header>
      </div>
    </LoadingProvider>
  );
}

export default App;
